<template>
  <div>
    <h6 v-if="data.length == 0" class="title-pages">
      VENDA DA EMPRESA PARA O RESIDENTE
    </h6>
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length == 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <!-- show-select -->
      <!-- v-model="selected" -->
      <v-data-table
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :expanded.sync="expanded"
        show-expand
        :footer-props="{
          'items-per-page-options': [5],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              ><h1 class="title-pages">
                VENDA DA EMPRESA PARA O RESIDENTE
              </h1></v-toolbar-title
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="item.status == 0" class="d-flex align-items-center">
            <span>FATURADO</span>
            <v-icon class="ml-2" small color="success">
              mdi-check-circle-outline
            </v-icon>
          </div>
          <div v-else class="d-flex align-items-center">
            <span>FATURAMENTO PENDENTE</span>
            <v-icon class="ml-2" small color="orange">
              mdi-information-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{
            item.stock_item_type == "PRODUCT"
              ? item.product_name
              : item.medicine_name
          }}
        </template>
        <template v-slot:[`item.stock_group`]="{ item }">
          {{ item.stock_group_name }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ item.amount }}
          {{ item.stock_item_unit_of_measurement_abbreviation }}
        </template>
        <template #[`item.lot`]="{ item }">
          {{ item.lot }}
        </template>
        <template #[`item.entry_date`]="{ item }">
          {{ moment(item.entry_date).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
        <template v-slot:[`item.total_value`]="{ item }">
          {{ formatPrice(item.total_value) }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="m-0 p-0" :colspan="headers.length">
            <item-details :item="item" />
          </td>
        </template>
      </v-data-table>
      <div v-if="data.length > 0" class="text-right mt-2">
        <h1 class="title-pages">TOTAL: R$ {{ formatPrice(total_value) }}</h1>
      </div>
      <ErrorsMessages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import ItemDetails from "./stock-sale-details.vue";

import {
  professionalClassCouncilValue,
  formatReal,
  formatPrice,
} from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "StockSale",

  components: {
    ErrorsMessages,
    ItemDetails,
  },

  props: {
    loading: Boolean,
    resident_id: [Number, String],
    data: Array,
    total_value: [Number, String],
    start: String,
    end: String,
  },

  data() {
    return {
      selected: [],
      expanded: [],

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "MEDICAMENTO", value: "name", sortable: false },
        { text: "GRUPO", value: "stock_group", sortable: false },
        { text: "QTD", value: "amount", sortable: false },
        { text: "LOTE", value: "lot", sortable: false },
        { text: "DATA DA VENDA", value: "entry_date", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "TOTAL FINAL", value: "total_value", sortable: false },
      ],

      errors: [],
    };
  },

  watch: {
    selected() {
      let ids = this.selected.map(({ id }) => id);
      this.$emit("selected", { type: "stock-sale", ids });
    },
  },

  methods: {
    moment,
    formatReal,
    formatPrice,
    professionalClassCouncilValue,
  },
};
</script>